import {
  CREATE_PRODUCT_VARIATION,
  CREATE_PRODUCT,
  TRACK_ADMIN_ACTION,
} from "../actions";

const initialState = {
  productVariation: {
    isLoading: false,
    loaded: false,
    error: false,
  },
  product: {
    isLoading: false,
    loaded: false,
    error: false,
  },
  action: {
    actionType: null,
    orderID: null,
    orderNumber: null,
    orderItemID: null,
    purchasedItemID: null,
    return: null,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case CREATE_PRODUCT_VARIATION.REQUEST:
      return {
        ...state,
        productVariation: {
          isLoading: true,
          loaded: false,
          error: false,
        },
      };
    case CREATE_PRODUCT_VARIATION.SUCCESS:
      return {
        ...state,
        productVariation: {
          isLoading: false,
          loaded: true,
          error: false,
        },
      };
    case CREATE_PRODUCT_VARIATION.FAILURE:
      return {
        ...state,
        productVariation: {
          isLoading: false,
          loaded: false,
          error: action.response.error,
        },
      };
    case CREATE_PRODUCT.REQUEST:
      return {
        ...state,
        product: {
          isLoading: true,
          loaded: false,
          error: false,
        },
      };
    case CREATE_PRODUCT.SUCCESS:
      return {
        ...state,
        product: {
          isLoading: false,
          loaded: true,
          error: false,
        },
      };
    case CREATE_PRODUCT.FAILURE:
      return {
        ...state,
        product: {
          isLoading: false,
          loaded: false,
          error: action.response.error,
        },
      };
    case TRACK_ADMIN_ACTION:
      return {
        ...state,
        action: {
          actionType: action.payload.actionType,
          orderID: action.payload.orderID,
          orderNumber: action.payload.orderNumber,
          orderItemID: action.payload.orderItemID,
          purchasedItemID: action.payload.purchasedItemID,
          return: action.payload.return,
        },
      };

    default:
      return state;
  }
}
